._stripedArea_b3ri4_1 {
  position: absolute; }
  ._stripedArea_b3ri4_1 ._stripeSvgRect_b3ri4_3 {
    fill: #c4c4c4; }
